var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasechainWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 32,
    rx: 6,
    fill: "#0052FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4086_107866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9169 26.3055C26.6346 26.3055 31.2698 21.6703 31.2698 15.9525C31.2698 10.2348 26.6346 5.59961 20.9169 5.59961C15.4922 5.59961 11.042 9.77177 10.6 15.0823H24.2842V16.8227H10.6C11.042 22.1333 15.4922 26.3055 20.9169 26.3055Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4086_107866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 20.8,
    fill: "white",
    transform: "translate(10.6 5.59961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasechainWhite);
export default __webpack_public_path__ + "static/media/BasechainWhite.0c4cca2645f2fd641ecbc9649b54f646.svg";
export { ForwardRef as ReactComponent };